import { request } from './request';

export const createReminder = (body) =>
  request(
    `reminders`,
    {
      method: 'POST',
      body,
    },
    'Reminder created successfully!',
  );

export const deleteReminder = (id) => {
  return request(
    `reminders/${id}`,
    { method: 'DELETE' },
    'Reminder deleted successfully!',
  );
};
